"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPermanentValueEventHandlerActivator = exports.SetPermanentValueEventHandlerArgs = void 0;
const EventHandlerType_1 = require("../EventHandlerType");
const Registries_1 = require("../../state/Registries");
class SetPermanentValueEventHandlerArgs {
    constructor(actor, key, value) {
        this.actor = actor;
        this.key = key;
        this.value = value;
        this.__type = EventHandlerType_1.EventHandlerType.SetPermanentValue;
        this.__typeName = "SetPermanentValue";
    }
}
exports.SetPermanentValueEventHandlerArgs = SetPermanentValueEventHandlerArgs;
let SetPermanentValueEventHandlerActivator = class SetPermanentValueEventHandlerActivator {
    activate(sequence, container, handler) {
        const { actor, key, value } = handler.args;
        container.setPermanent(actor, key, value);
    }
};
SetPermanentValueEventHandlerActivator = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.SetPermanentValue)
], SetPermanentValueEventHandlerActivator);
exports.SetPermanentValueEventHandlerActivator = SetPermanentValueEventHandlerActivator;
